module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAAXNSR0IArs4c6QAAACFQTFRFAAAAQ0lfQ0heQklfQUleQkhdQUldQkleQkhdQkldQUhdmALB/gAAAAp0Uk5TAFtcdMzN4+Tp/L8wR+8AAABJSURBVDjLY2AYBYMTZK1CA8tRpFdhAPpJR3SggZaRESXKxmjACEV6FnqgraRflBCwG8PlhiMjxjzQU2rroMlEVeiyy0bLvKEJAAjizGYS1A97AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/headerSettingIcon.png
// module id = p1fG
// module chunks = 1